import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import {MemberShipServiceTable} from "../../../UI/MembershipService/MemberShipServiceTable";

const MemberShipService = () => {
  return (
    <div>
      <PanelHead title="Membership Services" />
      <PanelBody content={<MemberShipServiceTable />} />
    </div>
  );
};

export default React.memo(MemberShipService);
